$(document).on('ajax:success', '#speakers-questions-form', function(event) {
  var data = event.detail[0];
  if(data['status'] === 'success') {
    $('#speakers_questions_question').val('')
    alert('Pytanie zostało wysłane.');
  } else {
    alert(data['message']);
  }
});
